import React, { type PropsWithChildren } from "react";
import classNames from "classnames";
import { isStorefrontNext } from "helpers/environment-helpers";

type DetailsProps = PropsWithChildren<{
  className: string;
  count?: number;
  isOpen: boolean;
  onToggle: () => void;
  title: string;
}>;

const Details = ({ isOpen, className, title, count, children, onToggle }: DetailsProps) => {
  const componentClassName = classNames("collapsible-menu", {
    [className]: className,
    active: isOpen,
    open: isOpen,
  });

  const renderSummaryCount = () => {
    if (count && isStorefrontNext()) {
      return <span className="text-xs bg-lighterGray flex items-center px-2 rounded-3xl">{count}</span>;
    }
    return null;
  };

  const renderHeader = () => {
    return (
      <button className="filter-fieldset-header" onClick={onToggle}>
        <p className="filter-fieldset-header__title minimizable">
          <span className="flex items-center gap-2">
            {title}
            {renderSummaryCount()}
          </span>
        </p>
      </button>
    );
  };

  return (
    <div className={componentClassName}>
      {renderHeader()}
      {children}
    </div>
  );
};

export default Details;
